module.exports = __webpack_public_path__ + "static/js/1.ff046d62.chunk.worker.js"